export function show({ element, enableInputs = true }) {
  element.classList.add('d-block');
  element.classList.remove('d-none');
  if (enableInputs) {
    element
      .querySelectorAll('input')
      .forEach((e) => e.removeAttribute('disabled'));
  }
}

export function hide({ element, disableInputs = true }) {
  element.classList.add('d-none');
  element.classList.remove('d-block');
  if (disableInputs) {
    element
      .querySelectorAll('input')
      .forEach((e) => e.setAttribute('disabled', 'disabled'));
  }
}
